import React, {Component} from 'react';
import './Article.css';

/**
 * Single column for readable content.
 */
class Article extends Component {
	render() {
		return (
			<article className={`Article ${this.props.className || ''}`}>{this.props.children}</article>
		);
	}
}

export default Article;



// WEBPACK FOOTER //
// ./src/widgets/Article.js